"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var SharedWidgets_1 = require("../../SharedWidgets");
/**
 * This Widget should be used *only* if the list of checkboxes forms a logical group with a visible label.
 * See https://www.w3.org/TR/wai-aria-practices-1.1/#checkbox
 */
// tslint:disable-next-line:max-line-length
var CheckBoxWithLabelGroupWidget = /** @class */ (function (_super) {
    tslib_1.__extends(CheckBoxWithLabelGroupWidget, _super);
    function CheckBoxWithLabelGroupWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckBoxWithLabelGroupWidget.prototype.render = function () {
        var _a;
        // tslint:disable-next-line:deprecation
        var _b = this.props, checkBoxWithLabelPropsList = _b.checkBoxWithLabelPropsList, children = _b.children, divProps = tslib_1.__rest(_b, ["checkBoxWithLabelPropsList", "children"]);
        return React.createElement("div", tslib_1.__assign({ role: 'group' }, divProps), children || ((_a = checkBoxWithLabelPropsList) === null || _a === void 0 ? void 0 : _a.map(function (props, index) { return React.createElement(SharedWidgets_1.CheckBoxWithLabelWidget, tslib_1.__assign({}, props, { key: index })); })));
    };
    return CheckBoxWithLabelGroupWidget;
}(React.PureComponent));
exports.CheckBoxWithLabelGroupWidget = CheckBoxWithLabelGroupWidget;
//# sourceMappingURL=CheckBoxWithLabelGroupWidget.js.map